<template>
  <v-container
    class="mx-auto pa-0"
  >
    <v-row no-gutters justify="center">
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('info')"
        :dark="isCurrentPage('info')"
        :outlined="!isCurrentPage('info')"
        color="doorMainColor"
        :small="isSmall"
      >
        基本情報
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('risk')"
        :dark="isCurrentPage('risk')"
        :outlined="!isCurrentPage('risk')"
        color="doorMainColor"
        :small="isSmall"
      >
        重症化リスク
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('medical')"
        :dark="isCurrentPage('medical')"
        :outlined="!isCurrentPage('medical')"
        color="doorMainColor"
        :small="isSmall"
      >
        問診
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('contact')"
        :dark="isCurrentPage('contact')"
        :outlined="!isCurrentPage('contact')"
        color="doorMainColor"
        :small="isSmall"
      >
        濃厚接触
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('confirm')"
        :dark="isCurrentPage('confirm')"
        :outlined="!isCurrentPage('confirm')"
        color="doorMainColor"
        :small="isSmall"
      >
        確認
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('result')"
        :dark="isCurrentPage('result')"
        :outlined="!isCurrentPage('result')"
        color="doorMainColor"
        :small="isSmall"
      >
        完了
      </v-chip>
    </v-row>
  </v-container>
</template>
<script>
import { defineComponent, computed } from 'vue'
import { useDisplay } from 'vuetify'

export default defineComponent({
  props: {
    page: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    const { mobile } = useDisplay()

    const isMobile = () => {
      return mobile.value
    }

    const isCurrentPage = (page) => {
      return page == props.page
    }

    const minWidth = computed(() => {
      return isMobile() ? '20px' : '124px'
    })

    const isSmall = computed(() => {
      return isMobile()
    })

    const vChipStyle = (page) => {
        return isCurrentPage(page)
          ? 'min-width: ' + minWidth.value + '; justify-content: center; font-weight: bold;'
          : 'min-width: ' + minWidth.value + '; justify-content: center;';
    }

    return {
      isMobile,
      isCurrentPage,
      minWidth,
      isSmall,
      vChipStyle
    }
  }
})
</script>
